import { createReducer } from '@reduxjs/toolkit';
import * as av from './audioVideoActions';
import { buildActionStatus, actionManager } from '../utils';

const initialState = {
  actionStatus: buildActionStatus(av),
  startWithAudio: false,
  startWithVideo: false,
};

const audioVideoReducer = createReducer(initialState, {
  [av.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [av.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [av.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [av.resetStateAction]: () => ({
    ...initialState,
  }),
  [av.startWithVideoAction]: (state, { payload }) => ({
    ...state,
    startWithVideo: payload,
  }),
  [av.startWithAudioAction]: (state, { payload }) => ({
    ...state,
    startWithAudio: payload,
  }),
});

export default audioVideoReducer;
